"use client";

import * as ga from "lib/ga";
import { useTranslation } from "react-i18next";
import { capitalize, slugify } from "shared/utils";

import styles from "./style.module.scss";

export default function PartnerKnowMore({ partner }) {
  const { name, resources } = partner;
  if (resources?.length === 0) {
    return null;
  }
  const { t } = useTranslation();

  const knowMoreClickable = (type) => {
    ga.event({
      action: "search",
      params: {
        search_term: `'Know More' clicked (${type})`,
      },
    });
  };

  const partnerKnowMore = (type, title) => {
    ga.event({
      action: "search",
      params: {
        search_term: `Partner Know More (${name} - ${type} (${title}))`,
      },
    });
  };

  return (
    <div className={styles.wrapper}>
      <h3>{t("know_more")}</h3>
      <ul className={styles.link_list}>
        {resources
          ?.filter((el) => typeof el !== "string")
          ?.map((resource, index) => {
            if (typeof resource !== "string") {
              const type = resource.type
                ? slugify("is_" + resource.type.trim())
                : "is_website";

              return (
                <li key={index}>
                  <a
                    href={
                      resource.link.startsWith("http")
                        ? resource.link
                        : `http://${resource.link}`
                    }
                    onClick={() => {
                      knowMoreClickable(capitalize(resource.type));
                      partnerKnowMore(
                        capitalize(resource.type),
                        resource.title
                      );
                    }}
                    rel="noreferrer"
                    target="_blank"
                  >
                    <div className={`${styles.icon} ${styles[type]}`} />
                    <div className={styles.info}>
                      <h4>{resource.title}</h4>
                      <small>{capitalize(resource.type)}</small>
                    </div>
                  </a>
                </li>
              );
            }
          })}
      </ul>
    </div>
  );
}
